import { BreadcrumbsComp } from '../../Components/BreadcrumbsComp';

export function Dashboard() {
  return (
    <div className="py-3">
      <BreadcrumbsComp title="Dashboard" paths={[]} />
    </div>
  );
}
